<div class="security-auth-detail">
  <div *ngIf="!selectItem" class="security-auth-detail__no-selection">{{ 'AUTHENTICATION.SELECT_A_COMPONENT_FROM_LIST' | translate }}</div>
  <div *ngIf="selectItem">
    <div class="security-auth-detail__title">{{ selectItem.translation }}</div>
    <div class="security-auth-detail__description">
      <label>{{ "GLOBAL.DESCRIPTION" | translate }}</label>
      <p>{{'AUTHENTICATION.OPTIONS_DESC_' +  (selectItem.key || selectItem.name) | translate}}</p>
    </div>
    <div class="security-auth-detail__value">
      <label>{{ "GLOBAL.VALUE" | translate }}</label>
      <bzg-input *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'text'"
        name="text" type="text" [(ngModel)]="selectItem.value || templateToShow" [disabled]="isDisabled"
        (ngModelChange)="selectItem.value = $event; onValueChange()">
      </bzg-input>
      <bzg-input name="number" *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'number'"
        type="number" [(ngModel)]="selectItem.value"
        [disabled]="isDisabled"
        [max]="selectedMetadata[(selectItem.key || selectItem.name)].max === -1 ? undefined : selectedMetadata[(selectItem.key || selectItem.name)].max"
        [min]="selectedMetadata[(selectItem.key || selectItem.name)]?.min"
        (ngModelChange)="onValueChange()">
        <bzg-min-error>{{ 'GLOBAL.INVALID_MIN_VALUE' | translate }} {{selectedMetadata[(selectItem.key || selectItem.name)].min}}</bzg-min-error>
        <bzg-max-error>{{ 'GLOBAL.INVALID_MAX_VALUE' | translate }} {{selectedMetadata[(selectItem.key || selectItem.name)].max}}</bzg-max-error>
      </bzg-input>
      <bzg-password name="password"
        *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'password'"
        [(ngModel)]="selectItem.value" [maxlength]="selectedMetadata[(selectItem.key || selectItem.name)].max"
        [disabled]="isDisabled"
        (ngModelChange)="onValueChange()">
      </bzg-password>
      <bzg-input name="email" *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'email'"
        type="email" [(ngModel)]="selectItem.value || templateToShow" [disabled]="isDisabled"
        (ngModelChange)="selectItem.value = $event; onValueChange()">
      </bzg-input>
      <textarea name="large-text"
        *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'text-large'" rows="8"
        class="security-auth-detail__textarea" [(ngModel)]="selectItem.value || templateToShow" [disabled]="isDisabled"
        (ngModelChange)="selectItem.value = $event; onValueChange()">
      </textarea>
      <bzg-switch name="boolean"
        *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'boolean'"
        [checked]="selectItem.value === 'True'" [disabled]="isDisabled"
        (change)="setCurrentBooleanValue($event)">
      </bzg-switch>
      <bzg-select name="list" *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'list'"
        [(value)]="selectItem.value" [disabled]="isDisabled" [checked]="currentValue === 'True'"
        (valueChange)="onValueChange()">
        <bzg-option
          *ngFor="let item of selectedMetadata[(selectItem.key || selectItem.name)].options | keyvalue"
          [value]="item.key">
          {{item.value}}
        </bzg-option>
      </bzg-select>
      
      <p *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'file'">{{currentFileName}}</p>
      <bzg-button-primary [disabled]="isDisabled" (click)="uploadFile()"
        *ngIf="selectedMetadata[(selectItem.key || selectItem.name)].type === 'file'">
        <svg class="bz-icon-svg bz-icon-svg--16">
          <use xlink:href="#icon-upload"></use>
        </svg>
        {{ 'AUTHENTICATION.BUTTON_BROWSE' | translate }}
      </bzg-button-primary>
      <input #fileUploaded type="file" style="display: none" type="file" [accept]="currentAllowedExtensions"
        (change)="readFile($event.target)">
      <div class="security-auth-detail__apply">
        <bzg-button-primary
          (click)="updateData()"
          [disabled]="isDisabled || !isFormValid()">
          {{ "GLOBAL.APPLY" | translate }}
        </bzg-button-primary>
      </div>
    </div>
  </div>
</div>
